import {
  ADD_CHITTIE_AUCTION_STARTED,
  ADD_CHITTIE_AUCTION_COMPLETED,
  ADD_CHITTIE_AUCTION_ERROR,
  FETCH_CHITTIE_AUCTION_STARTED,
  FETCH_CHITTIE_AUCTION_COMPLETED,
  FETCH_CHITTIE_AUCTION_ERROR,
  ADD_AUCTION_PAYMENT_STARTED,
  ADD_AUCTION_PAYMENT_COMPLETED,
  ADD_AUCTION_PAYMENT_ERROR,
  UPDATE_AUCTION_STARTED,
  UPDATE_AUCTION_COMPLETED,
  UPDATE_AUCTION_ERROR,
  FETCH_MINUTES_STARTED,
  FETCH_MINUTES_COMPLETED,
  FETCH_MINUTES_ERROR,
  DELETE_AUCTION_STARTED,
  DELETE_AUCTION_COMPLETED,
  DELETE_AUCTION_ERROR
} from '../actionTypes/chittieAuctionActionTypes';

const INITIAL_STATE = {
  submitted: false,
  success: false,
  error: false,
  chittieAuctions: {},
  minutes: {}
};

function chittieAuctionReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_CHITTIE_AUCTION_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_CHITTIE_AUCTION_COMPLETED: {
      let auctionKey = Object.keys(action.payLoad);
      let auctionValue = action.payLoad[auctionKey];
      state.chittieAuctions[auctionKey] = auctionValue;
      return {
        ...state,
        chittieAuctions: { ...state.chittieAuctions },
        submitted: false,
        success: true
      };
    }
    case ADD_CHITTIE_AUCTION_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_CHITTIE_AUCTION_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_CHITTIE_AUCTION_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          chittieAuctions: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FETCH_CHITTIE_AUCTION_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case ADD_AUCTION_PAYMENT_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_AUCTION_PAYMENT_COMPLETED: {
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case ADD_AUCTION_PAYMENT_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case UPDATE_AUCTION_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case UPDATE_AUCTION_COMPLETED: {
      Object.keys(state.chittieAuctions).filter((key) => {
        if (key === action.payLoad.id) {
          state.chittieAuctions[key].minuteDate = action.payLoad.minuteDate;
          state.chittieAuctions[key].documents = action.payLoad.documents;
        }
      });
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case UPDATE_AUCTION_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_MINUTES_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_MINUTES_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          minutes: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FETCH_MINUTES_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case DELETE_AUCTION_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case DELETE_AUCTION_COMPLETED: {
      let result = {};
      Object.keys(state.chittieAuctions).filter((key) => {
        if (key !== action.payLoad) {
          result[key] = state.chittieAuctions[key];
        }
      });
      return {
        ...state,
        chittieAuctions: {...result},
        submitted: false,
        success: true
      };
    }
    case DELETE_AUCTION_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    default:
      return state;
  }
}

export default chittieAuctionReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/chittieAuctionReducer.js